/**
 * Marca del backend para visitas que MedicalProtocol genera aunque ningún
 * concepto del contrato las liquide: llegan igual, a valor 0 y con alerta,
 * para que no desaparezcan de la grilla. El API sólo publica los valores
 * (0, 1, 2) sin nombre; únicamente 0 ("no es placeholder") está confirmado,
 * cualquier otro valor se trata como visita sin concepto que la liquide.
 */
export enum VisitPlaceholderTypeEnum {
    None = 0,
}
